import { useSEO } from '../../hooks/useSEO';

const ImpressumPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'Impressum | Bamme-Media',
    description: 'Impressum und rechtliche Informationen von Bamme-Media - Webdesign und Online Marketing Agentur.',
    keywords: 'Impressum, rechtliche Informationen, Bamme-Media',
    canonical: `${siteUrl}/impressum`,
    robots: 'noindex, nofollow, noarchive, nosnippet',
    ogTitle: 'Impressum | Bamme-Media',
    ogDescription: 'Impressum und rechtliche Informationen von Bamme-Media - Webdesign und Online Marketing Agentur.',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Impressum",
      "description": "Impressum und rechtliche Informationen von Bamme-Media",
      "url": `${siteUrl}/impressum`,
      "isPartOf": {
        "@type": "WebSite",
        "name": "Bamme-Media",
        "url": siteUrl
      },
      "about": {
        "@type": "Organization",
        "name": "Bamme-Media",
        "url": siteUrl
      }
    }
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl border border-white/20 shadow-2xl p-8">
          <h1 className="text-4xl font-bold text-white mb-8 text-center">Impressum</h1>
          
          <div className="space-y-8 text-white/90">
            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
              <h2 className="text-xl font-semibold text-white mb-3">Angaben gemäß § 5 TMG</h2>
              <div className="space-y-2">
                <p><strong className="text-white">Bamme-Media</strong></p>
                <p>Inhaber: Dion Dawan Bamme</p>
                <p>38855 Wernigerode</p>
                <p>Deutschland</p>
              </div>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
              <h2 className="text-xl font-semibold text-white mb-3">Kontakt</h2>
              <div className="space-y-2">
                <p><strong className="text-white">Telefon:</strong> 017645725863</p>
                <p><strong className="text-white">E-Mail:</strong> bamme.media@gmail.com</p>
                <p><strong className="text-white">Website:</strong> https://dionbamme.com</p>
              </div>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
              <h2 className="text-xl font-semibold text-white mb-3">Umsatzsteuer-ID</h2>
              <p>
                Als Kleinunternehmer nach § 19 UStG wird keine Umsatzsteuer ausgewiesen.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
              <h2 className="text-xl font-semibold text-white mb-3">Berufsbezeichnung und berufsrechtliche Regelungen</h2>
              <div className="space-y-2">
                <p><strong className="text-white">Berufsbezeichnung:</strong> Webdesigner und Online Marketing</p>
                <p><strong className="text-white">Verliehen in:</strong> Deutschland</p>
                <p><strong className="text-white">Es gelten folgende berufsrechtliche Regelungen:</strong></p>
                <p>Gewerbeordnung (GewO), Telemediengesetz (TMG), Bundesdatenschutzgesetz (BDSG)</p>
              </div>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
              <h2 className="text-xl font-semibold text-white mb-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
              <div className="space-y-2">
                <p>Dion Dawan Bamme</p>
                <p>38855 Wernigerode</p>
                <p>Deutschland</p>
              </div>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
              <h2 className="text-xl font-semibold text-white mb-3">EU-Streitschlichtung</h2>
              <p className="mb-4">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 underline ml-1">
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
              <p>
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
              <h2 className="text-xl font-semibold text-white mb-3">Verbraucherstreitbeilegung/Universalschlichtungsstelle</h2>
              <p>
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
              <h2 className="text-xl font-semibold text-white mb-3">Haftung für Inhalte</h2>
              <p className="mb-4">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              </p>
              <p className="mb-4">
                Verpflichtungen zur Entfernung und Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
              <h2 className="text-xl font-semibold text-white mb-3">Haftung für Links</h2>
              <p className="mb-4">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
              </p>
              <p className="mb-4">
                Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
              <h2 className="text-xl font-semibold text-white mb-3">Urheberrecht</h2>
              <p className="mb-4">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
              </p>
              <p className="mb-4">
                Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
              <h2 className="text-xl font-semibold text-white mb-3">Bildnachweise</h2>
              <p>
                Die auf dieser Website verwendeten Bilder und Grafiken unterliegen dem Urheberrecht. Soweit nicht anders angegeben, stammen alle Bilder von:
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Eigene Aufnahmen und Grafiken</li>
                <li>Kundenspezifische Materialien mit entsprechender Nutzungserlaubnis</li>
              </ul>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
              <h2 className="text-xl font-semibold text-white mb-3">Technische Umsetzung</h2>
              <div className="space-y-2">
                <p><strong className="text-white">Hosting:</strong> GoDaddy.com</p>
                <p><strong className="text-white">Content Management:</strong> React, TypeScript, Tailwind CSS</p>
                <p><strong className="text-white">Design & Entwicklung:</strong> Bamme-Media</p>
              </div>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
              <h2 className="text-xl font-semibold text-white mb-3">Rechtswirksamkeit dieses Haftungsausschlusses</h2>
              <p>
                Dieser Haftungsausschluss ist als Teil des Internetangebotes zu betrachten, von dem aus auf diese Seite verwiesen wurde. Sofern Teile oder einzelne Formulierungen dieses Textes der geltenden Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen sollten, bleiben die übrigen Teile des Dokuments in ihrem Inhalt und ihrer Gültigkeit davon unberührt.
              </p>
            </div>

            <div className="bg-blue-500/20 backdrop-blur-sm rounded-xl p-4 border border-blue-400/30">
              <p className="text-sm text-blue-200">
                <strong>Hinweis:</strong> Dieses Impressum wurde zuletzt am {new Date().toLocaleDateString('de-DE')} aktualisiert. Änderungen behalten wir uns vor.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImpressumPage;